// Central list of image files. Import `Images` and use `Images.<name>` (e.g.
// `<img src={Images.termLifePlan} alt="" />`) instead of importing an image file directly, and add
// new images here. Older screens still import their files directly and move over gradually.
import buySellPlan from "./svg/bs-img.svg";
import keyPersonPlan from "./svg/kpi-img.svg";
import splitDollarPlan from "./svg/sd-img.svg";
import premiumFinancePlan from "./PlansIcons/PremiumFinance.png";
import termLifePlan from "./svg/term-life-img.svg";
import permanentLifePlan from "./svg/permanent-life-img.svg";
import standardPlans from "./svg/standard-plan-img.svg";
import strategicPlans from "./svg/strategic-plan-img.svg";
import specialtyPlans from "./svg/specialty-plan-img.svg";

export const Images = {
  // Plan types: the Plans page's Plan Type column and Create Proposal (purple→teal artwork).
  buySellPlan,
  keyPersonPlan,
  splitDollarPlan,
  premiumFinancePlan,
  termLifePlan,
  permanentLifePlan,
  // Plan classifications: Create Proposal's category headers (brand navy→blue artwork).
  standardPlans,
  strategicPlans,
  specialtyPlans,
};
